var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rcomparisonchart"
  }, [_c('r-component-header', {
    staticClass: "rcomparisonchart--header mb-6"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "align-content": "space-between"
    }
  }, [_c('v-col', {
    staticStyle: {
      "width": "220px"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-start"
  }, [_c('r-select', {
    key: "rcomparisonchart--rselect",
    staticClass: "rcomparisonchart--firstdropdown p-0 mr-2",
    attrs: {
      "items": _vm.getSeriesOneItems,
      "show-search": false,
      "allow-empty": false
    },
    on: {
      "change": _vm.onChangeSeriesOne
    }
  }), _c('r-button', {
    staticClass: "rcomparisonchart--icons mr-1",
    attrs: {
      "color": "#FFBE0A",
      "small": "",
      "fab": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" mdi-chart-line-variant ")])], 1), _c('r-button', {
    staticClass: "rcomparisonchart--icons",
    attrs: {
      "color": "#4CA15A",
      "fab": "",
      "small": "",
      "disabled": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" mdi-poll ")])], 1)], 1)]), _c('v-col', {
    attrs: {
      "width": "220px"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('r-button', {
    staticClass: "rcomparisonchart--icons mr-1",
    attrs: {
      "color": "#FFBE0A",
      "small": "",
      "fab": "",
      "disabled": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" mdi-chart-line-variant ")])], 1), _c('r-button', {
    staticClass: "rcomparisonchart--icons",
    attrs: {
      "color": "#4CA15A",
      "fab": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" mdi-poll ")])], 1), _c('r-select', {
    key: "rcomparisonchart--rselect",
    staticClass: "rcomparisonchart--seconddropdown p-0 ml-2",
    attrs: {
      "items": _vm.getSeriesTwoItems,
      "show-search": false,
      "allow-empty": false
    },
    on: {
      "change": _vm.onChangeSeriesTwo
    }
  })], 1)])], 1), _vm.loading ? _c('v-row', [_c('v-skeleton-loader', {
    attrs: {
      "type": "image",
      "width": "100%",
      "height": "350"
    }
  })], 1) : _c('v-row', [_c('v-col', [_c('div', {
    key: _vm.renderCount,
    staticClass: "rcomparisonchart-c"
  }, [_c('highcharts', {
    staticClass: "serieschart",
    attrs: {
      "options": _vm.chartOptions()
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }